import customerSaga from './sagas/CustomerSaga';
import nfcSage from './sagas/NfcSaga';

export default [
    customerSaga,
    nfcSage
];